// SCREEN_SEARCH (検索) で使うAPI

export const searchVtubers = async (
  filters = {},
  page = 1,
  sort = "new",
  prefTags = [],
) => {
  const name = filters?.vtuberName ?? "";

  const tags = Object.entries(filters)
    .filter(
      ([key, value]) =>
        key !== "vtuberName" && key !== "includeUnapproved" && value !== "",
    )
    .map(([_, value]) => value);
  
  const userId = localStorage.getItem("user")

  const params = new URLSearchParams({
    page,
    name,
    tags: tags.join(","),
    sort,
    userId
  });
  if (prefTags.length > 0) {
    params.set("prefTags", prefTags.join(","));
  }

  const response = await fetch(
    `https://daikou-diverse-api.com/api/data_202608/search/?${params.toString()}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  const data = await response.json();

  return [data.items, data.total];
};
